import { n as r } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
/**
 * @copyright Copyright (c) 2020 Raimund Schlüßler <raimund.schluessler@mailbox.org>
 *
 * @author Raimund Schlüßler <raimund.schluessler@mailbox.org>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const l = (e, t) => {
  const s = [];
  let h = 0, n = e.toLowerCase().indexOf(t.toLowerCase(), h), i = 0;
  for (; n > -1 && i < e.length; )
    h = n + t.length, s.push({ start: n, end: h }), n = e.toLowerCase().indexOf(t.toLowerCase(), h), i++;
  return s;
}, a = {
  name: "NcHighlight",
  props: {
    /**
     * The string to display
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * The string to match and highlight
     */
    search: {
      type: String,
      default: ""
    },
    /**
     * The ranges to highlight, takes precedence over the search prop.
     */
    highlight: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    /**
     * The indice ranges which should be highlighted.
     * If an array with ranges is provided, we use it. Otherwise
     * we calculate it based on the provided substring to highlight.
     *
     * @return {Array} The array of ranges to highlight
     */
    ranges() {
      let e = [];
      return !this.search && this.highlight.length === 0 || (this.highlight.length > 0 ? e = this.highlight : e = l(this.text, this.search), e.forEach((t, s) => {
        t.end < t.start && (e[s] = {
          start: t.end,
          end: t.start
        });
      }), e = e.reduce((t, s) => (s.start < this.text.length && s.end > 0 && t.push({
        start: s.start < 0 ? 0 : s.start,
        end: s.end > this.text.length ? this.text.length : s.end
      }), t), []), e.sort((t, s) => t.start - s.start), e = e.reduce((t, s) => {
        if (!t.length)
          t.push(s);
        else {
          const h = t.length - 1;
          t[h].end >= s.start ? t[h] = {
            start: t[h].start,
            end: Math.max(t[h].end, s.end)
          } : t.push(s);
        }
        return t;
      }, [])), e;
    },
    /**
     * Calculate the different chunks to show based on the ranges to highlight.
     *
     * @return {Array} The chunks
     */
    chunks() {
      if (this.ranges.length === 0)
        return [{
          start: 0,
          end: this.text.length,
          highlight: !1,
          text: this.text
        }];
      const e = [];
      let t = 0, s = 0;
      for (; t < this.text.length; ) {
        const h = this.ranges[s];
        if (h.start === t) {
          e.push({
            ...h,
            highlight: !0,
            text: this.text.slice(h.start, h.end)
          }), s++, t = h.end, s >= this.ranges.length && t < this.text.length && (e.push({
            start: t,
            end: this.text.length,
            highlight: !1,
            text: this.text.slice(t)
          }), t = this.text.length);
          continue;
        }
        e.push({
          start: t,
          end: h.start,
          highlight: !1,
          text: this.text.slice(t, h.start)
        }), t = h.start;
      }
      return e;
    }
  },
  /**
   * The render function to display the component
   *
   * @param {Function} h The function to create VNodes
   * @return {object} The created VNode
   */
  render(e) {
    return this.ranges.length ? e("span", {}, this.chunks.map((t) => t.highlight ? e("strong", {}, t.text) : t.text)) : e("span", {}, this.text);
  }
}, u = null, o = null;
var c = /* @__PURE__ */ r(
  a,
  u,
  o,
  !1,
  null,
  null,
  null,
  null
);
const d = c.exports;
export {
  l as F,
  d as N
};
